import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AuditLog, AuditLogFilter } from '../data/auditLog';

export function createAuditLogService(client: AxiosInstance) {
  return createCrudService<AuditLog, AuditLog, AuditLogFilter>(client,
    "/audit/AuditLog",
    "auditLogId",
  );
}

export type AuditLogService = CrudService<AuditLog, AuditLog, AuditLogFilter>;
